import { useState } from "react";

export const useToggle = (initialState = false): [boolean, () => void] => {
  const [state, setState] = useState(initialState);
  const toggle: () => void = () => {
    setState((state) => !state);
  };

  return [state, toggle];
};
